var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 15.272 15.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-whatsapp",
    "data-name": "Icon simple-whatsapp",
    d: "M11.135,9.152c-.192-.1-1.124-.552-1.3-.615s-.3-.1-.428.1-.491.613-.6.739-.222.134-.411.048a5.165,5.165,0,0,1-1.529-.945A5.773,5.773,0,0,1,5.811,7.158c-.111-.191-.012-.3.083-.391s.192-.22.287-.333a1.613,1.613,0,0,0,.189-.316.35.35,0,0,0-.016-.333c-.048-.1-.428-1.031-.587-1.4s-.31-.325-.428-.325-.236-.01-.363-.01a.717.717,0,0,0-.507.228A2.124,2.124,0,0,0,3.8,5.85,3.723,3.723,0,0,0,4.58,7.807a8.485,8.485,0,0,0,3.245,2.854c.454.191.808.305,1.084.4a2.633,2.633,0,0,0,1.2.077,1.958,1.958,0,0,0,1.283-.907,1.575,1.575,0,0,0,.115-.907c-.047-.086-.172-.134-.363-.22M7.675,13.84h-.01a6.366,6.366,0,0,1-3.217-.878l-.229-.136-2.386.62.64-2.319-.152-.239A6.311,6.311,0,0,1,12.15,3.1,6.229,6.229,0,0,1,14,7.551a6.319,6.319,0,0,1-6.322,6.29M13.058,2.195A7.726,7.726,0,0,0,7.665,0,7.566,7.566,0,0,0,1.079,11.351L0,15.272l4.031-1.051a7.676,7.676,0,0,0,3.634.921h0a7.6,7.6,0,0,0,7.6-7.57A7.505,7.505,0,0,0,13.048,2.22",
    fill: "#25d366",
    opacity: 0.509
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.940a2f23f8aebe5e5cc7a322bbadcb56.svg";
export { ForwardRef as ReactComponent };